//import 'node_modules/bootstrap'
import '@/bootstrap'
import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import lodash from 'lodash'
import '@/components'
import "@/plugins"
import "@/filters"
import "@/directives"
import App from '@/App.vue'

const createApp = async () => {
    const params = new URLSearchParams(location.search)
    let error = null
    if ((error = params.get('error'))) {
        store.dispatch(
            'notification/push',
            {
                text: error,
                color: 'danger',
            }
        )
    }

    new Vue({
        el: '#app',
        router,
        store,
        components: { App },
        template: '<App />',
    })

    // global
    Vue.prototype.$_ = lodash

    // config
    Vue.config.debug = true
    Vue.config.devtools = true

    window.setInterval(() => {
        store.dispatch('auth/me', { SILENT: true, })
    }, 60 * 1000)

    window.setInterval(() => {
        store.dispatch('notification/process')
    }, 100)
}

createApp()

